import rsLogo from "../../../assets/logos/pfLogo.jpg";
import rsLogoA from "../../../assets/logos/logoRSazul.jpeg";

const LogosDashboard = () => {
    const images = [
        { id: 2, src: rsLogoA, alt: "RS" },
        { id: 1, src: rsLogo, alt: "RS" },
    ];

    return (
        <div className="w-full flex flex-row justify-around">
            {images.map((image) => (
                <img
                    src={image.src} alt={image.alt} key={image.id}
                    className="h-32 hover:animate-pulse transition-transform duration-300 hover:scale-105 hover:drop-shadow-lg rounded-lg"
                />
            ))}
        </div>
    );
};

export default LogosDashboard;
